var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.computedCardClasses }, [
    _c(
      "div",
      { staticClass: "tw-mb-2 tw-flex tw-items-center tw-gap-2" },
      [
        _vm._t("label", function () {
          return [
            _c(
              "label",
              {
                class: _vm.computedLabelClasses,
                attrs: { for: _vm.controlId, id: _vm.controlId + "-label" },
              },
              [
                _c("i", {
                  class: _vm.displayIcon,
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("\n        " + _vm._s(_vm.displayLabel) + "\n        "),
                _vm.mandatory
                  ? _c(
                      "abbr",
                      {
                        staticClass: "tw-text-red-600 tw-ml-1 tw-no-underline",
                        attrs: { title: "obligatoire" },
                      },
                      [_vm._v("*")]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tw-flex-1" },
      [
        _vm._t("default", null, {
          autocomplete: _vm.autocomplete,
          controlId: _vm.controlId,
          mandatory: _vm.mandatory,
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }